import { render, staticRenderFns } from "./definetest.vue?vue&type=template&id=df9c4436&"
import script from "./definetest.vue?vue&type=script&lang=js&"
export * from "./definetest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports